import React from 'react';

import PropTypes from 'prop-types';

import Icons from '../icons/Icons';

import './InformationAlert.scss';

const InformationAlert = ({ icon, children }) => (
  <div className="information-alert">
    <div className="information-alert__icon">
      <Icons iconName={icon} size={20} />
    </div>
    <div className="information-alert__content">{children}</div>
  </div>
);

InformationAlert.defaultProps = {
  icon: 'info-circle'
};

InformationAlert.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node
};

export default InformationAlert;
